import { useState } from "react";
import { useInfiniteQuery } from "react-query";
import { getJobReviews } from "services/job.service";
import { PaginationQuery } from "types/http.type";

export default function useJobReviews(jobId: string, limit: number = 20) {
  const [refreshing, setRefreshing] = useState(false);

  const fetchRecords = async ({ pageParam = 1 }) => {
    const query: PaginationQuery = {
      page: pageParam,
      limit,
    };
    const response = await getJobReviews(jobId, query);

    return {
      results: response.data.data,
      totalPages: Math.ceil(response.data.total / limit),
      nextPage: pageParam + 1,
    };
  };

  const {
    data,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery(["jobReviews", jobId], fetchRecords, {
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.nextPage < lastPage.totalPages) return lastPage.nextPage;
      return undefined;
    },
    enabled: jobId ? true : false,
  });

  const records = data?.pages.map((page) => page.results)?.flat();
  const handleRefresh = async () => {
    setRefreshing(true);
    await refetch();
    setRefreshing(false);
  };
  const handleEndReached = async () => {
    if (hasNextPage) {
      await fetchNextPage();
    }
  };

  return {
    data: records,
    isLoading,
    isFetchingNextPage,
    refreshing,
    handleRefresh,
    handleEndReached,
    hasNextPage,
  };
}
